import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

type SidebarState = {
  isOpen: boolean
  actions: {
    toggle: () => void
    open: () => void
    close: () => void
  }
}

export const useSidebarStore = create<SidebarState>()(
  subscribeWithSelector(set => ({
    isOpen: true,
    actions: {
      toggle: () => {
        set(state => ({ isOpen: !state.isOpen }))
      },
      open: () => {
        set({ isOpen: true })
      },
      close: () => {
        set({ isOpen: false })
      },
    },
  })),
)
